module.exports = __webpack_public_path__ + "img/word-pic.e43b1251.png";